import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Kopeeri

  <span style="color:#85c1dc;">**FI:**</span>
  Kopioida

  <span style="color:#85c1dc;">**RU:**</span>
  Копировать
*/
/* @__NO_SIDE_EFFECTS__ */
const m237 = msg(
  mf`Kopeeri`,
  mf`Kopioida`,
  mf`Копировать`,
)

export { m237 as 'w.wishlist.share.copy.button.text' }